import { makeStyles } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { STATUS_API, PAGE_SIZE_LIST } from 'src/app/constant/config';
import { getListStaff } from 'src/features/staffSlice';
import Results from './Results.js';
import ToolBar from './ToolBar.js';
import { useQuery } from 'src/app/hooks/useQuery.js';
import { _convertObjectToQuery } from 'src/app/utils/apiService.js';

const ServiceStaff = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const classes = useStyles();
  const query = useQuery();

  const statusCreate = useSelector(state => state.staffSlice.statusCreate);
  const statusDelete = useSelector(state => state.staffSlice.statusDelete);
  const statusUpdate = useSelector(state => state.staffSlice.statusUpdate);
  const statusDeleteMultiStaff = useSelector(
    state => state.staffSlice.statusDeleteMultiStaff
  );
  const agencyId = useSelector(state => state.authSlice.agencyId);
  const listStaff = useSelector(state => state.staffSlice.listStaff);
  const page = query.get('page') || 1;
  const keywords = query.get('keywords');

  const [params, setParams] = useState({
    page: 1,
    page_size: PAGE_SIZE_LIST
  });

  useEffect(() => {
    const queryValue = {
      ...params,
      page: page ? Number(page) : 1,
      keywords: keywords || undefined
    };
    setParams(queryValue);
  }, [query]);

  useEffect(() => {
    dispatch(getListStaff({ agency_id: agencyId || undefined, ...params }));
  }, [agencyId, params.page, params.keywords]);

  const getListStaffsWithParams = queryObj => {
    const data = queryObj?.data || queryObj;
    const newParams = { ...params, ...data };
    navigate('/app/manage/service-staffs?' + _convertObjectToQuery(data));
    setParams(newParams);
    dispatch(getListStaff({ agency_id: agencyId || undefined, ...newParams }));
  };

  useEffect(() => {
    if (
      statusCreate === STATUS_API.SUCCESS ||
      statusDelete === STATUS_API.SUCCESS ||
      statusUpdate === STATUS_API.SUCCESS ||
      statusDeleteMultiStaff === STATUS_API.SUCCESS
    ) {
      dispatch(getListStaff({ agency_id: agencyId || undefined, ...params }));
    }
  }, [statusCreate, statusDelete, statusUpdate, statusDeleteMultiStaff]);

  return (
    <>
      <div className={classes.root}>
        <div style={{ width: '98%', margin: '0 auto' }}>
          <ToolBar searchRef={getListStaffsWithParams} />
          <Results
            className="mt-3"
            listStaff={listStaff}
            getListStaffRef={getListStaffsWithParams}
            params={params}
            setParams={setParams}
          />
        </div>
      </div>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    //height: '100%',
    width: '100%',
    marginTop: '17px'
  },
  wrapper: {
    display: 'flex',
    position: 'relative',
    flex: '1 1 auto',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
}));

export default ServiceStaff;
